/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, { useState } from 'react';

function UpdateInvoiceInformationModal({
    updateInvoiceModal, setUpdateInvoiceModal, updateInvoiceInformation, setUpdateInvoiceInformation, handleUpdateInvoiceinformation, setErrorIndication, errorIndication, subitButtonDisable,
}) {
    const toggleState = {
        payment_mode: false,
        payment_type: false,

    };
    const [toggle, settoggle] = useState(toggleState);
    const InputChange = (e, key) => {
        e.preventDefault();
        const { id, value } = e.target;
        setUpdateInvoiceInformation((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };
    const handleDropdownStatus = () => {
        settoggle(toggleState);
    };

    const handleToggle = (key) => {
        handleDropdownStatus();
        const val = key === 'start_date' ? 'end_date' : 'start_date';
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
            [val]: false,
        }));
    };
    return (
        <div className={`modal fade fixed top-0 left-0 ${updateInvoiceModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="updateInvoice" tabIndex="-1" aria-labelledby="updateInvoiceModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none min-w-[449px] sm:max-w-[449px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current px-4 py-[18px]">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[18px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full invoice" id="exampleModalScrollableLabel1">
                            Update Invoice
                        </h5>
                        <button
                            type="button"
                            className="absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setUpdateInvoiceModal(false)}
                        >
                            <img src="/images/Icon-ionic-ios-close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-[30px] px-3 sm:pt-[34px] sm:pb-7 pb-[24px] text-center">
                        <form className="w-full">
                            <div className="relative">
                                <label htmlFor="payment_note" className="text-xs2 font-semibold text-[#808285] absolute top-[-11px] left-3 px-1 bg-[#ffffff]">
                                    Payment Note
                                    {' '}
                                    <span className="text-[#ED1C24]">*</span>
                                </label>
                                <textarea
                                    name="enterMoremessage"
                                    id="payment_note"
                                    className={`w-full h-[123px] resize-none px-[13px] py-[14px] ${(errorIndication && updateInvoiceInformation.payment_note === '') ? 'border-[#ED1C24]' : 'border-[#B1B4B7]'} border rounded-lg text-base font-normal text-[#090406] outline-none custom-scrollbar err-MsgInvoiceBorder`}
                                    onChange={(e) => {
                                        InputChange(e);
                                        setErrorIndication(false);
                                    }}
                                    value={updateInvoiceInformation.payment_note}

                                />
                                <p className="absolute bottom-[3px] right-5 px-1 bg-[#FFFFFF] text-xs13 font-normal text-[#808285]">500 words</p>
                            </div>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice pt-0.5">This field is required</p>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice1 pt-0.5">Text is too long .Please limit it to 500 characters.</p>
                            <div className="relative mt-[27px]">
                                <label htmlFor="payment_ref_no" className="text-xs2 font-semibold text-[#808285] absolute top-[-11px] left-3 px-1 bg-[#ffffff]">
                                    Payment Ref. Number
                                    {' '}
                                    <span className="text-[#ED1C24]">*</span>
                                </label>
                                <input
                                    name="enterMoremessage"
                                    id="payment_ref_no"
                                    className={`w-full px-[13px] py-[11px] ${(errorIndication && updateInvoiceInformation.payment_ref_no === '') ? 'border-[#ED1C24]' : 'border-[#B1B4B7]'} border rounded-lg text-base font-normal text-[#090406] outline-none err-MsgInvoiceBorder`}
                                    onChange={(e) => {
                                        InputChange(e);
                                        setErrorIndication(false);
                                    }}
                                    value={updateInvoiceInformation.payment_ref_no}

                                />
                            </div>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice pt-0.5">This field is required</p>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice1 pt-0.5">Invalid Reference Number</p>
                            <div className="w-full mt-[27px]">
                                <div className="dropdown relative">
                                    <button
                                        type="button"
                                        id="Special14"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        className={`dropdown-to flex justify-between items-center h-12 w-full rounded-lg outline-0 border ${(errorIndication && updateInvoiceInformation.payment_type === '') ? 'border-[#ED1C24]' : 'border-[#B1B4B7]'} bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 err-MsgInvoiceBorder`}
                                        onClick={() => {
                                            handleToggle('payment_type');
                                            setErrorIndication(false);
                                        }}
                                    >
                                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                                            Payment Type
                                            <span className="text-[#ED1C24]">*</span>
                                        </p>
                                        {updateInvoiceInformation.payment_type === '' ? <span className="text-[#AAA6AF] text-base font-normal text-left">Choose Payment Mode</span> : <span className="text-[#090406] text-base font-normal text-left">{updateInvoiceInformation.payment_type}</span>}
                                        <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                    </button>
                                    <ul style={{ top: '48px' }} className={`dropdown-menu w-full absolute top-7 right-0 bg-[#FFFFFF] rounded-[10px] ${toggle.payment_type ? '' : 'hidden'} shadow-s2 z-[9999] pb-2.5 pr-1 py-3 max-h-[140px] overflow-auto custom-scrollbar`} aria-labelledby="special14">
                                        <li
                                            className="w-full bg-[#ffffff] pt-2"
                                            onClick={() => {
                                                setUpdateInvoiceInformation((prevState) => ({
                                                    ...prevState,
                                                    payment_type: 'PAID',
                                                }));
                                                settoggle((prevState) => ({
                                                    ...prevState,
                                                    payment_type: false,
                                                }));
                                            }}
                                        >
                                            <a href="javascript:void(0)" className="w-full dropdown-item inline-block text-base font-normal text-[#090406] text-left pl-[11px]">
                                                Paid
                                            </a>
                                        </li>
                                        <li
                                            className="w-full bg-[#ffffff] pt-2"
                                            onClick={() => {
                                                setUpdateInvoiceInformation((prevState) => ({
                                                    ...prevState,
                                                    payment_type: 'PARTIAL',
                                                }));
                                                settoggle((prevState) => ({
                                                    ...prevState,
                                                    payment_type: false,
                                                }));
                                            }}
                                        >
                                            <a href="javascript:void(0)" className="w-full dropdown-item inline-block text-base font-normal text-[#090406] text-left pl-[11px]">
                                                Partial
                                            </a>
                                        </li>
                                        <li
                                            className="w-full bg-[#ffffff] pt-2"
                                            onClick={() => {
                                                setUpdateInvoiceInformation((prevState) => ({
                                                    ...prevState,
                                                    payment_type: 'PENDING',
                                                }));
                                                settoggle((prevState) => ({
                                                    ...prevState,
                                                    payment_type: false,
                                                }));
                                            }}
                                        >
                                            <a href="javascript:void(0)" className="w-full dropdown-item inline-block text-base font-normal text-[#090406] text-left pl-[11px]">
                                                Pending
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice pt-0.5">This field is required</p>
                            <div className="w-full mt-[27px]">
                                <div className="dropdown relative">
                                    <button
                                        type="button"
                                        id="special14"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        className={`dropdown-to flex justify-between items-center h-12 w-full rounded-lg outline-0 border ${(errorIndication && updateInvoiceInformation.payment_mode === '') ? 'border-[#ED1C24]' : 'border-[#B1B4B7]'} bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 err-MsgInvoiceBorder`}
                                        onClick={() => {
                                            handleToggle('payment_mode');
                                            // setsubmitSelected(false);
                                            setErrorIndication(false);
                                        }}
                                    >
                                        <p className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                                            Payment Mode
                                            <span className="text-[#ED1C24]">*</span>
                                        </p>
                                        {updateInvoiceInformation.payment_mode === '' ? <span className="text-[#AAA6AF] text-base font-normal text-left">Choose Payment Mode</span> : <span className="text-[#090406] text-base font-normal text-left">{updateInvoiceInformation.payment_mode}</span>}
                                        <img src="/images/chevron-red-down1.svg" alt="icon" className="absolute top-[22px] right-5" />
                                    </button>
                                    <ul style={{ top: '48px' }} className={`dropdown-menu w-full absolute top-7 right-0 bg-[#FFFFFF] ${toggle.payment_mode ? '' : 'hidden'} rounded-[10px] shadow-s2 z-[9999] pb-2.5 pr-1 py-3 max-h-[140px] overflow-auto custom-scrollbar`} aria-labelledby="special14">
                                        <li
                                            className="w-full bg-[#ffffff] pt-2"
                                            onClick={() => {
                                                setUpdateInvoiceInformation((prevState) => ({
                                                    ...prevState,
                                                    payment_mode: 'NEFT',
                                                }));
                                                settoggle((prevState) => ({
                                                    ...prevState,
                                                    payment_mode: false,
                                                }));
                                            }}
                                        >
                                            <a href="javascript:void(0)" className="w-full dropdown-item inline-block text-base font-normal text-[#090406] text-left pl-[11px]">
                                                NEFT
                                            </a>
                                        </li>
                                        <li
                                            className="w-full bg-[#ffffff] pt-2"
                                            onClick={() => {
                                                setUpdateInvoiceInformation((prevState) => ({
                                                    ...prevState,
                                                    payment_mode: 'RTGS',
                                                }));
                                                settoggle((prevState) => ({
                                                    ...prevState,
                                                    payment_mode: false,
                                                }));
                                            }}
                                        >
                                            <a href="javascript:void(0)" className="w-full dropdown-item inline-block text-base font-normal text-[#090406] text-left pl-[11px]">
                                                RTGS
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <p className="text-xs13 font-normal text-[#ED1C24] text-left hidden err-MsgInvoice pt-0.5">This field is required</p>
                        </form>
                        <div className="flex w-full mt-6 pb-1">
                            <div className="flex justify-center w-full">
                                <button
                                    type="submit"
                                    id="confirm"
                                    disabled={subitButtonDisable === true}
                                    className="w-[284px] sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold text-[#FFFFFF] invoice-proceded"
                                    onClick={() => handleUpdateInvoiceinformation()}
                                >
                                    Proceed
                                </button>
                                <p className="pt-1 text-sm58 font-normal text-[#090406] invoice-content hidden">Updated by John Doe on 13/05/2022 12:45pm</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateInvoiceInformationModal;
